export default __webpack_public_path__ + "static/media/cinnamonroll-image.39d4d9f0.png";